var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_2872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1142 6H6.88583C6.6509 6 6.42558 6.09333 6.25945 6.25945C6.09333 6.42558 6 6.6509 6 6.88583V17.1142C6 17.3491 6.09333 17.5744 6.25945 17.7405C6.42558 17.9067 6.6509 18 6.88583 18H17.1142C17.3491 18 17.5744 17.9067 17.7405 17.7405C17.9067 17.5744 18 17.3491 18 17.1142V6.88583C18 6.6509 17.9067 6.42558 17.7405 6.25945C17.5744 6.09333 17.3491 6 17.1142 6ZM9.57667 16.2225H7.7725V10.4917H9.57667V16.2225ZM8.67333 9.6975C8.46868 9.69635 8.26896 9.6346 8.09937 9.52004C7.92978 9.40549 7.79792 9.24327 7.72044 9.05384C7.64296 8.86442 7.62332 8.6563 7.66402 8.45573C7.70471 8.25516 7.8039 8.07114 7.94908 7.92689C8.09425 7.78264 8.27891 7.68463 8.47973 7.64523C8.68056 7.60583 8.88856 7.6268 9.07748 7.70549C9.2664 7.78419 9.42777 7.91708 9.54123 8.08741C9.6547 8.25773 9.71516 8.45785 9.715 8.6625C9.71693 8.79952 9.69126 8.93552 9.63951 9.0624C9.58776 9.18928 9.51099 9.30445 9.41379 9.40103C9.31658 9.49762 9.20092 9.57364 9.07371 9.62458C8.9465 9.67551 8.81033 9.70031 8.67333 9.6975ZM16.2267 16.2275H14.4233V13.0967C14.4233 12.1733 14.0308 11.8883 13.5242 11.8883C12.9892 11.8883 12.4642 12.2917 12.4642 13.12V16.2275H10.66V10.4958H12.395V11.29H12.4183C12.5925 10.9375 13.2025 10.335 14.1333 10.335C15.14 10.335 16.2275 10.9325 16.2275 12.6825L16.2267 16.2275Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_2872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f371e06a14d709d38abdd101344bb69c.svg";
export { ForwardRef as ReactComponent };